import { Injectable } from '@angular/core';
import { CustomHttpService } from '@services/generals/custom-http.service';
import { AbstractService } from "@services/abstract.service";
import { EmployeeClass } from "@classes/employee.class";

@Injectable({providedIn: 'root'})
export class EmployeeService extends AbstractService {
    constructor(
        public customHttpService: CustomHttpService,
    ) {
        super(customHttpService, new EmployeeClass());
        this.version = 'v1';
    }

  /** Función que inserta el Modelo */
  public create = () => {
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpPOST(
          true,
          true,
          url + this.modelClass.modelName + '/Create_EmployeeUser',
          self.modelClass.getJsonBase(),
          null,
          self.modelClass
        ).then(
          (response) => {
            if (response === false) { resolve(response); }
            resolve(true);
          }
        );
      }
    );
  }

  public getAllActive(): Promise<any>{
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName + '/GetAllActiveEmpleyies').then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response;
            resolve(true);
          }
        );
      }
    );
  }

  public getAll(): Promise<any>{
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName).then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response;
            resolve(true);
          }
        );
      }
    );
  }

  public getByID = (id: number) => {
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName + '/GetEmployeeByID/' + id).then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response['data'];
            self.modelClass.set(response['data']);
            resolve(true);
          }
        );
      }
    );
  }

  public getProfile = () => {
    const self = this;
    const url = self.version + self.base;
    return new Promise(
      resolve => {
        self.customHttpService.httpGET(true, true, url + this.modelClass.modelName + '/GetPerfil').then(
          (response) => {
            if (response === false) { resolve(response); }
            self.data = response['data'];
            self.modelClass.set(response['data']);
            resolve(true);
          }
        );
      }
    );
  }

  public sendCode = (email: string) => {
    const self = this;
    const url = self.version + self.base;
    const json = {
      "email": email,
      "password": ""
    };
    return new Promise(
      resolve => {
        self.customHttpService.httpPOST(
          true,
          true,
          url + this.modelClass.modelName + '/PasswordRecovery',
          json,
          null,
          self.modelClass
        ).then(
          (response) => {
            if (response === false) { resolve(response); }
            resolve(true);
          }
        );
      }
    );
  }

  public passwordReset = (passwordReset: string, newPassword: string) => {
    const self = this;
    const url = self.version + self.base;
    const json = {
      "passwordReset": passwordReset,
      "newPassword": newPassword
    };
    return new Promise(
      resolve => {
        self.customHttpService.httpPOST(
          true,
          true,
          url + this.modelClass.modelName + '/ResetPassword',
          json,
          null,
          self.modelClass
        ).then(
          (response) => {
            if (response === false) { resolve(response); }
            resolve(true);
          }
        );
      }
    );
  }

}
